import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";

export class EndpointService {
  static async registerEndpoint(
    endpointUrl: string,
    auth: string,
    p256dh: string,
    username: string
  ) {
    const apiConfig = {
      api: APIs.Endpoint.RegisterEndpoint,
      parameters: null,
      body: {
        endpointUrl: endpointUrl,
        auth: auth,
        p256dh: p256dh,
        username: username
      },
    };
    await SafeairManager.invoke(apiConfig);
  };

  static async removeRegisterEndpoint(
    username: string
  ) {
    const apiConfig = {
      api: APIs.Endpoint.RemoveregisterEndpoint,
      parameters: {
        "username": username,
      },
      body: null
    };
    await SafeairManager.invoke(apiConfig);
  };

  static async getRegisterEndpoint(
    username: string
  ) {
    const apiConfig = {
      api: APIs.Endpoint.GetRegisterEndPoint,
      parameters: {
        "username": username,
      },
      body: null
    };
    let response = await SafeairManager.invoke(apiConfig);
    return response.data.endpointUrl;
  };

  static async notifyWebUser (
    title: string,
    message: string,
    username: string[]
  ) {
    const apiConfig = {
      api: APIs.Endpoint.webNotification,
      parameters: null,
      body: {
        title: title,
        message: message,
        usernames: username
      },
    };
    await SafeairManager.invoke(apiConfig);
  }
}
